import React from 'react'

import './styles.scss'
import InputLabel from 'components/forms/InputLabel'
import ErrorWrapper from 'components/forms/ErrorWrapper'

/**
 * Input text
 * @param {object} props
 * @param {function} props.onChange
 * @param {string} [props.value]
 * @param {boolean} [props.disabled]
 * @param {boolean} [props.required]
 * @param {string} [props.className]
 * @param {string} [props.placeholder]
 * @param {string} [props.htmlFor]
 * @param {string} [props.title]
 * @param {string} [props.error]
 * @param {number} [props.minLength]
 *
 * @returns {React.Component}
 */
const Textarea = (props) => {
  const {
    value = '', onChange, disabled = false,
    className = '', placeholder = null, required = false,
    htmlFor = null, title = '', onClickEdit, displayEdit = false,
    error = '', minLength = null
  } = props

  return (
    <div className={`nx-input-textarea ${className}`}>
      <InputLabel
        title={title}
        htmlFor={htmlFor}
        displayEdit={displayEdit}
        onClickEdit={onClickEdit}
      />
      <ErrorWrapper
        text={error}
      >
        <textarea
          className={`nx-input-textarea__input ${error ? 'nx-field-error': ''}`}
          type='text'
          id={htmlFor}
          name={htmlFor}
          value={value}
          placeholder={placeholder}
          onChange={({ target: { value } }) => {
            onChange(value)
          }}
          required={required}
          disabled={disabled}
          minLength={minLength}
        />
      </ErrorWrapper>
    </div>
  )
}

export default Textarea
